export class NavigationInfo {
  communityId?: string;
  customerId?: string;
  navCode?: string;
  view?: string;
}
